// removed by extract-text-webpack-plugin
module.exports = {"box":"box__3-Fgd","heading":"heading__lLQwT","content":"content__12U91","text":"text__1-k5W","tips":"tips__ZWJjG","button":"button__cBWEZ"};


//////////////////
// WEBPACK FOOTER
// ./styles/invest/redirectedToDirectCard.scss
// module id = 1165
// module chunks = 68